/*
  Shift modular sections · timeline rail
  On narrow desktop widths the release rail scrolls sideways. When it does,
  make it a focusable, labelled region so keyboard users can scroll it with
  the arrow keys; when everything fits, it stays a plain list.
  Custom element, so it re-initialises on shopify:section:load by itself.
*/
(function () {
  if (customElements.get('sr-timeline-rail')) return;

  class SRTimelineRail extends HTMLElement {
    connectedCallback() {
      this.schedule = this.schedule.bind(this);
      this.list = this.querySelector('ol, ul');
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
      if (this.list) this.resizeObserver.observe(this.list);
      window.addEventListener('resize', this.schedule, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.schedule);
      window.cancelAnimationFrame(this.frame);
    }

    schedule() {
      window.cancelAnimationFrame(this.frame);
      this.frame = window.requestAnimationFrame(() => this.update());
    }

    update() {
      const scrolls = this.scrollWidth - this.clientWidth > 1;
      if (scrolls) {
        this.setAttribute('tabindex', '0');
        this.setAttribute('role', 'region');
        if (this.dataset.labelId) this.setAttribute('aria-labelledby', this.dataset.labelId);
      } else {
        this.removeAttribute('tabindex');
        this.removeAttribute('role');
        this.removeAttribute('aria-labelledby');
      }
    }
  }

  customElements.define('sr-timeline-rail', SRTimelineRail);
})();
